import { createFileRoute, redirect } from '@tanstack/react-router';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { schemaTemplateResolver_ListByDivisions } from 'cpool-tables/backend-resolvers';
import { z } from 'zod';

import { ROLES } from '~/constants.ts';
import { authoriseUser } from '~/features/auth/utils/authoriseUser.ts';
import { getQueryOptions } from '~/queryUtils/getQueryOptions.ts';
import { useUserStore } from '~/store/userStore.ts';

const divisionsTemplatesSearchSchema = z.object({
    divisionId: z.string().optional(),
});

const divisionsTemplatesQueryOptions = () => {
    return getQueryOptions({
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: 'listByDivisions',
        schema: schemaTemplateResolver_ListByDivisions,
        searchParams: {},
    });
};

export const Route = createFileRoute('/_app/management/templates/divisions/$templateId')({
    beforeLoad: ({ location }) => {
        authoriseUser([ROLES.admin, ROLES.email_manager], location);
        const content = 'ROUTE_TITLE.TEMPLATES';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: async ({ context, location }) => {
        const { user } = useUserStore.getState();
        if (!user) {
            throw redirect({ search: { redirect: location.href }, to: '/login' });
        }
        await context.queryClient.ensureQueryData(divisionsTemplatesQueryOptions());
    },
    loaderDeps: ({ search }) => search,
    validateSearch: divisionsTemplatesSearchSchema,
});
